export const getColorFromConfig = (
    key: string,
    config: Array<{ key: string; color: string }> = []
): string => {
    const item = config.find((it) => it.key === key);
    return item?.color || '#607D8B';
};

